"use client";

import type { ReactNode } from "react";
import { useState } from "react";
import { QUICK_ANSWER_SECTIONS } from "./quickAnswersData";
const SUPPORT_PORTAL_TEXT = "help.signaturestaycollection.com";
const SUPPORT_PORTAL_HREF = "mailto:help.signaturestaycollection.com";
const renderParagraph = (paragraph: string): ReactNode => {
  const supportPortalIndex = paragraph.indexOf(SUPPORT_PORTAL_TEXT);
  if (supportPortalIndex === -1) {
    return paragraph;
  }
  const beforeLink = paragraph.slice(0, supportPortalIndex);
  const afterLink = paragraph.slice(supportPortalIndex + SUPPORT_PORTAL_TEXT.length);
  return <>
      {beforeLink}
      <a href={SUPPORT_PORTAL_HREF} className='text-accent-500 underline decoration-[1.5px] underline-offset-4 transition-colors'>
        {SUPPORT_PORTAL_TEXT}
      </a>
      {afterLink}
    </>;
};
const QuickAnswersAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);
  let itemIndex = -1;
  return <div className='w-full' data-sentry-component="QuickAnswersAccordion" data-sentry-source-file="QuickAnswersAccordion.tsx">
      {QUICK_ANSWER_SECTIONS.map(section => <section key={section.heading} className='mb-12 last:mb-0 lg:mb-16'>
          <h3 className='mb-6 text-[22px] font-semibold leading-[1.2] text-brand-dark md:mb-7 md:text-[24px] lg:mb-8 lg:text-[28px] lg:leading-[1.3]'>
            {section.heading}
          </h3>

          <div className='space-y-1'>
            {section.items.map(item => {
          const currentIndex = itemIndex + 1;
          itemIndex = currentIndex;
          const isOpen = openIndex === currentIndex;
          return <div key={item.question} className='border-t border-[#bfc6cc] last:border-b'>
                  <button type='button' aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? -1 : currentIndex)} className='flex w-full items-start gap-3 py-4 text-left lg:py-5'>
                    <span aria-hidden='true' className='mt-0.5 w-4 shrink-0 text-center text-[20px] font-semibold leading-none text-accent-500 md:text-[22px] lg:text-[24px]'>
                      {isOpen ? "-" : "+"}
                    </span>
                    <span className='text-[16px] font-semibold leading-[1.35] text-accent-500 md:text-[18px] lg:text-[22px] lg:leading-[1.45]'>
                      {item.question}
                    </span>
                  </button>

                  {isOpen && <div className='mb-3 rounded-[4px] bg-[rgba(244,242,233,0.5)] px-5 py-4'>
                      <div className='space-y-3 text-[14px] leading-[1.5] text-brand-dark md:text-[16px] lg:text-[18px] lg:leading-[1.55]'>
                        {(item.answer.paragraphs ?? []).map(paragraph => <p key={paragraph}>{renderParagraph(paragraph)}</p>)}

                        {item.answer.orderedList && <ol className='list-decimal space-y-2 pl-5 marker:font-semibold marker:text-brand-dark'>
                            {item.answer.orderedList.map(step => <li key={step} className='pl-1'>
                                {step}
                              </li>)}
                          </ol>}

                        {item.answer.unorderedList && <ul className='list-disc space-y-2 pl-5 marker:text-brand-dark'>
                            {item.answer.unorderedList.map(bullet => <li key={bullet} className='pl-1'>
                                {bullet}
                              </li>)}
                          </ul>}
                      </div>
                    </div>}
                </div>;
        })}
          </div>
        </section>)}

      <section className='mt-12 space-y-8 pt-2 lg:mt-16 lg:space-y-10 lg:pt-4'>
        <div className='space-y-3'>
          <h3 className='text-[22px] font-semibold leading-[1.2] text-brand-dark md:text-[24px] lg:text-[28px] lg:leading-[1.3]'>
            Trouble Booking?
          </h3>
          <div className='space-y-2 text-[14px] leading-[1.5] text-brand-dark md:text-[16px] lg:text-[18px] lg:leading-[1.55]'>
            <p>
              If you run into issues during checkout, contact us at{" "}
              <a href={SUPPORT_PORTAL_HREF} className='text-accent-500 underline decoration-[1.5px] underline-offset-4 transition-colors'>
                help.signaturestaycollection.com
              </a>{" "}
              via live chat, email, or phone. Our team will help you complete
              your booking.
            </p>
          </div>
        </div>

        <div className='space-y-3'>
          <h3 className='text-[22px] font-semibold leading-[1.2] text-brand-dark md:text-[24px] lg:text-[28px] lg:leading-[1.3]'>
            Still Need Help?
          </h3>
          <div className='space-y-2 text-[14px] leading-[1.5] text-brand-dark md:text-[16px] lg:text-[18px] lg:leading-[1.55]'>
            <p>
              For property search or pre-booking support:{" "}
              <a href='mailto:travelagents@whimstay.com' className='text-accent-500 underline decoration-[1.5px] underline-offset-4 transition-colors'>
                travelagents@whimstay.com
              </a>
            </p>
            <p>
              For help with an existing booking:{" "}
              <a href='mailto:support@whimstay.com' className='text-accent-500 underline decoration-[1.5px] underline-offset-4 transition-colors'>
                support@whimstay.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default QuickAnswersAccordion;